export enum PermissionCodeEnum {
	ConfigurationMenu = 'CONFIGURATION_MENU',

	// Users.
	UserCreate = 'USER::CREATE',
	UserExport = 'USER::EXPORT',
	UserRead = 'USER::READ',
	UserUpdate = 'USER::UPDATE',
	UserDelete = 'USER::DELETE',
	UserResetPassword = 'USER::RESET_PASSWORD',
	UserAssignRole = 'USER::ASSIGN_ROLE',
	AuditTrailsRead = "AUDIT_TRAIL::READ",

	// Roles.
	RoleCreate = 'ROLE::CREATE',
	RoleRead = 'ROLE::READ',
	RoleUpdate = 'ROLE::UPDATE',
	RoleDelete = 'ROLE::DELETE',
	RoleAssignUser = 'ROLE::ASSIGN_USER',
}
